import { RequestConfig } from '~/common/services/requests';
import { Category } from '../../../types';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { CATEGORIES_BASE_PATH } from '../constants/categoriesBasePath';

export const getCategories = async (
  constructPost: ConstructPost,
  params?: RequestConfig['params'],
): Promise<NonPaginatedResponse<Category[]> | undefined> =>
  constructPost<NonPaginatedResponse<Category[]>>(CATEGORIES_BASE_PATH, {
    params,
  });
